<div
  class="relative rounded border border-dashed border-transparent [&.editable:hover]:border-[rgba(0,0,0,0.2)] [&.selected]:border-[rgba(63,81,181,0.8)]"
  [class.selected]="selected$ | async"
  [class.editable]="editable$ | async"
>
  <div
    *ngIf="(editable$ | async) && (selected$ | async)"
    class="absolute right-1 top-1 z-[1] flex items-center gap-1 rounded bg-[rgba(255,255,255,0.9)] px-1 shadow-[0_1px_3px_rgba(0,0,0,0.2)]"
    contenteditable="false"
  >
    <span class="text-[11px] font-medium tracking-[0.5px] text-[rgba(0,0,0,0.6)]">HTML</span>
    <button
      mat-icon-button
      matTooltip="Edit HTML"
      aria-label="Edit HTML"
      (click)="edit()"
    >
      <mat-icon>code</mat-icon>
    </button>
  </div>
  <pt-raw-html-preview [html]="html$ | async" />
</div>
